import React, { useState, useEffect, useFocus } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  mdiHome,
  mdiChevronDoubleRight,
  mdiDelete,
  mdiCartArrowDown,
  mdiPlus,
  mdiPrinter,
  mdiCartOutline,
  mdiPencil,
  mdiPlusCircleOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import { getUrl } from "utils/utils";
import configs from "../../../constants/configs";
import { Index_GetConfigAllSTKey } from "actions/DanhMuc/";
import { pushNotification } from "utils/notifications";
import numeral from "numeral";
import { CustomerParseFloat } from "utils/currencyFormat";
import { convertDate } from "utils/currencyFormat";
import { formatDayMonth } from "utils/currencyFormat";
import LayoutNew from "../../../common/LayoutNoLogin";
import { TitlePage } from "common/TitlePage";
import iconDate from "Resources/ImagesNew/iconDate.png";
import { convertToNumber } from "utils/currencyFormat";
import moment from "moment";
//import "moment/locale/vi";
import LangugeVi from "../../../constants/vi";
import { ThongTinKhachHang } from "./ThongTinKhachHang";
import { ThongTinHangBan } from "./ThongTinHangBan";
import { TableSanPham } from "./TableSanPham";
import { TableSanPhamSanPhamXaGo } from "./TableSanPhamSanPhamXaGo";
import { ThongTinThanhToan } from "./ThongTinThanhToan";
import { Index_getDMStore } from "actions/DanhMuc/";
import DanhMucNewApi from "../../../service/DanhMucNewApi";
import HeThongNTApi from "../../../service/HeThongNT/HeThongNTApi";
import { Cookies } from "react-cookie";
import momentLocalizer from "react-widgets-moment";
import { DateTimePicker } from "react-widgets";
import ChiNhanhApi from "../../../service/DanhMucService/ChiNhanhApi";
moment.locale("vi", LangugeVi.VietNamese);
momentLocalizer(moment);

const cookies = new Cookies();
cookies.set("userTokenDaiLy", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImtoYWNobGUiLCJuYmYiOjE3NjczNDQwMjksImV4cCI6MTc5ODg4MDAyOSwiaWF0IjoxNzY3MzQ0MDI5LCJpc3MiOiJuaWVtdGluIiwiYXVkIjoibmllbXRpbiJ9.IC5JL_lwjIXmv1ylsAcG7ql_4eeFivhlPb9bKIEPfno", { path: "/DatHangNgoai" });
cookies.set("userDaiLy", "Khách lẻ|Khách lẻ", { path: "/DatHangNgoai" });
export const ThemMoiDatHangNgoai = () => {
  document.title = "Đặt hàng";
  const dispatch = useDispatch();

  // Chọn tổng chi nhánh sẽ nhảy về chi nhánh 1

  const constCategoryNow = {
    TenDonViNhap: "Đơn vị bán",
    TiTrong: 0,
    StoreID: 0,
    iOption: -1,
    RateForSale: 1,
    Quantity: 1,
    Note: "",
    ThueGTGT: 0,
    OrderBaoGiaID: 0,
    IdDonViNhapView: 0,
    IdDonViXuatView: 0,
    objCongThucSanPham: {
      KyHieu: [],
      CongThuc: "",
      CongThucID: 0,
    },
  };

  const [categoryNow, setCategoryNow] = useState(constCategoryNow);

  const initData = {
    OrderDatHangID: 0,
    OrderCode: "",
    CreatedTime: new Date(),
    UpdatedTime: new Date(),
    CreatedUser: "Khách lẻ",
    UpdatedUser: "",
    Note: "",
    CustomerID: 0,
    CustomerName: "",
    CustomerAddress: "",
    Phone: "",
    AccountBank: "",
    TaxCode: "",
    TotalAmount: 0,
    TotalPaid: 0,
    TotalPaidOlder: 0,
    StoreExportStatus: 1 /*1 trừ kho - 0 không trừ kho*/,
    IsAddTax: true,
    DatePaid: new Date(),
    OtherFee: 0,
    CustomerDebt: 0,
    ChietKhau: 0,
    GiaoHang: true,
    Approval: 0,
    BankId: 0 /*ngân hàng*/,
    TypeMoney: 0,
    NgayTao: new Date(),
    NgayCapNhat: new Date(),
    BranchID: 0,
    ChietKhau_CongThuc: "",
    IsAutoTruKho: false,
    TrangThaiGiaoNhan: 0,
    NgayDuKienGiao: new Date(new Date().getTime() + 1 * 60000),
    IsDuHang: true,
    TotalAmountThueGTGT: 0,
    IsLayHoaDon: false,
    ThueGTGT: 0,
    HanThanhToan: null,
    POCode: "",
    lstChiTiet: [],
    NVKD: "",
    NVKDID: 0,
    BranchName: "",
    IsDoiTac: true,
    isShowThueGTGT: false,
    isRoleGiaoNhan: null,
    TotalAmountNew: 0,
    SoNgayNo: 0,
    sUserName: "Khách lẻ",
    isShowGiaVon: false,
    BankName: "Tiền mặt",
    ConfigSuaNgay: null,
    ConfigPhienBan: null,
    ConfigThueGTGT: null,
    ConfigCanhBaoDHQuaHan: null,
    ConfigMaPO: null,
    ConfigNhanVienKinhDoanh: null,
    ConfigChuaGiCong: null,
    ConfigTruKhoGiaCong: null,
    configThuocTinhKhac: "0",
    ConfigBanBuonBanLe: null,
    ConfigTiTrong: null,
    configChietKhau: null,
    configDateChiTietDH: null,
    ConfigBanAm: null,
    ConfigTruKhoVaoNgayTao: null,
    ConfigSuaSanPhamBanHang: null,
    ConfigShowTTKTheoNhom: null,
    ConfigMauHoaDon: "",
    ConfigThanhToanDHCu: null,
    ConfigLamTronTien: null,
    ConfigCongThucCK: null,
    ConfigPhanBoCongNoTheoSanPham: null,
    ChietKhau_NhomSP: 0,
    DiaChiGiaoHang: "",
    ListAddress: [],
    TinhThanhPho: 0,
    QuanHuyen: 0,
    XaPhuong: 0,
    lstDinhKhoan: [],
    lstLoaiPBCNQuaHan: [],
  };

  const [valueSanPham, setValueSanPham] = useState(0);
  const [dataBanHang, setDataBanHang] = useState(initData);
  const [listChietKhauNhomKH, setListChietKhauNhomKH] = useState({});
  const [value, setValue] = useState("");


  const [StoreID, setStoreID] = useState("");
  const [DHQuaHanThanhToan, setDHQuaHanThanhToan] = useState(0);
  const [activePage, setPageActive] = React.useState(1);

  //sửa
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let sCode = params.get("Id") ?? params.get("id");
  const [disEditKH, setDisEditKH] = useState(false);
  const [disEditDonGia, setDisEditDonGia] = useState(false);
  const [disEditAll, setDisEditAll] = useState(false);
  const [listNVKD, setListNVKD] = useState([]);

  const initNVKD = {
    List: [],
    List2: {},
  };
  const [listNVKDNew, setListNVKDNew] = useState(initNVKD);

  const [getLink, setGetLink] = useState();
  const [roleBanHang, setRoleBanHang] = useState(true);
  const [isShowMenu, setIsShowMenu] = useState(false);

  const [listChietKhauNhom, setListChietKhauNhom] = useState([]);
  const [isShowNVKDNew, setIsShowNVKDNew] = useState(null);
  //Check Quyền
  const [valueTotalTTK, setValueTotalTTK] = useState(0);
  const [tenNhomSP, setTenNhomSP] = useState(" ");
  const [listNhomSP, setListNhomSP] = useState([]);
  const [GoiPhanMem, setGoiPhanMem] = useState("1");
  const [HienthiAutotrukhogiacong, setHienthiAutotrukhogiacong] = useState("0");
  const [isShowGiaBan, setIsShowGiaBan] = useState(null);
  const user = useSelector((state) => state.user);
  const [roleDate, setRoleDate] = useState();
  const [roleHanThanhToan, setRoleHanThanhToan] = useState();
  const [roleGiaVon, setRoleGiaVon] = useState(true);
  const [roleBanCuon, setRoleBanCuon] = useState(true);
  const [roleSuaSP, setRoleSuaSP] = useState(true);
  const [roleMaMc, setRoleMaMc] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [IsFocusTenSanPham, setFocusTenSanPham] = useState(false);
  useEffect(() => {
    dispatch(Index_getDMStore({ iBranch: 1 }));
    dispatch(Index_GetConfigAllSTKey());
    //End gọi cấu hình
    var totalChietKhauNhom = 0;
    // Kiểm tra hiển thị lọc tỉnh thành
    DanhMucNewApi.getAllConfigSTKey().then((response) => {
      if (response.data.List.length > 0) {
        if (isShowTinhThanh === null && isShowNVKDNew == null) {
          const configKGCXaGo = response.data.List.find(
            (e) => e.KeyID.toUpperCase() === configs.sKey.KGCXaGo.toUpperCase()
          );

          setIsKGCXaGo(false);
          if (typeof configKGCXaGo !== "undefined" && configKGCXaGo != null) {
            if (configKGCXaGo.Value === "1") {
              setIsKGCXaGo(true);
            }
          }
          //
          const configDinhKhoanKeToan = response.data.List.find(
            (e) =>
              e.KeyID.toUpperCase() ===
              configs.sKey.isDinhKhoanKeToan.toUpperCase()
          );

          setIsDinhKhoanKeToan(false);
          if (
            typeof configDinhKhoanKeToan !== "undefined" &&
            configDinhKhoanKeToan != null
          ) {
            if (configDinhKhoanKeToan.Value === "1") {
              setIsDinhKhoanKeToan(true);
            }
          }

          const configTatCanhBaoLuongTon = response.data.List.find(
            (e) =>
              e.KeyID.toUpperCase() ===
              configs.sKey.TatCanhBaoLuongTon.toUpperCase()
          );

          setTatCanhBaoLuongTon(false);
          if (
            typeof configTatCanhBaoLuongTon !== "undefined" &&
            configTatCanhBaoLuongTon != null
          ) {
            if (configTatCanhBaoLuongTon.Value === "1") {
              setTatCanhBaoLuongTon(true);
            }
          }
          //
          const configShowTinhThanh = response.data.List.find(
            (e) =>
              e.KeyID.toUpperCase() ===
              configs.sKey.BanHangLocTinhThanh.toUpperCase()
          );
          setIsShowTinhThanh(false);
          if (
            typeof configShowTinhThanh !== "undefined" &&
            configShowTinhThanh != null &&
            configShowTinhThanh.Value
          ) {
            if (configShowTinhThanh.Value === "1") {
              setIsShowTinhThanh(true);
            }
          }

          //

          const configNVKDNew = response.data.List.find(
            (e) => e.KeyID.toUpperCase() === configs.sKey.NVKD.toUpperCase()
          );
          setIsShowNVKDNew(false);
          if (typeof configNVKDNew !== "undefined" && configNVKDNew != null) {
            if (configNVKDNew.Value === "1") {
              setIsShowNVKDNew(true);
            }
          }

          //
        }
        if (isShowGiaBan == null) {
          //

          const configisShowGiaBan = response.data.List.find(
            (e) =>
              e.KeyID.toUpperCase() ===
              configs.sKey.giaBanTheoSoLuong.toUpperCase()
          );
          setIsShowGiaBan(false);
          if (
            typeof configisShowGiaBan !== "undefined" &&
            configisShowGiaBan != null
          ) {
            if (configisShowGiaBan.Value === "1") {
              setIsShowGiaBan(true);
            }
          }

          //
        }
      }
    });
    DanhMucNewApi.getAllConfigSTKey().then((response) => {
      if (isShowTinhThanh === null) {
        //
        const configShowTinhThanh = response.data.List.find(
          (e) =>
            e.KeyID.toUpperCase() ===
            configs.sKey.BanHangLocTinhThanh.toUpperCase()
        );
        console.log("configShowTinhThanh", configShowTinhThanh);
        setIsShowTinhThanh(false);
        if (
          typeof configShowTinhThanh !== "undefined" &&
          configShowTinhThanh != null &&
          configShowTinhThanh.Value
        ) {
          if (configShowTinhThanh.Value === "1") {
            setIsShowTinhThanh(true);
          }
        }
      }
      if (response.data.List.length > 0) {
        const sConfigTruTheKHo = response.data.List.find(
          (e) =>
            e.KeyID.toUpperCase() === configs.sKey.AutoTruKho.toUpperCase()
        );
        if (
          typeof sConfigTruTheKHo !== "undefined" &&
          sConfigTruTheKHo != null &&
          sConfigTruTheKHo.Value
        ) {
          if (sConfigTruTheKHo.Value === "1") {
            setDataBanHang({
              ...dataBanHang,
              IsAutoTruKho: true,
            });
          }
        }
      }
    });

    HeThongNTApi.getDTimeSys().then((response) => {
      if (response.status === 200) {
        dataBanHang.CreatedTime = convertDate(response.data);
        dataBanHang.UpdatedTime = convertDate(response.data);
      }
    });

  }, []);
  const [isShowTinhThanh, setIsShowTinhThanh] = useState(null);
  const [IsFocusKho, setFocusKho] = useState(false);
  const danhmuc = useSelector((state) => state.danhmuc);
  const { objDataStore, objConfigAll } = danhmuc;
  const [lamTron, setLamTron] = useState(null);
  const [isKGCXaGo, setIsKGCXaGo] = useState(null);
  const [isDinhKhoanKeToan, setIsDinhKhoanKeToan] = useState(null);
  const [tatCanhBaoLuongTon, setTatCanhBaoLuongTon] = useState(null);
  const [isNhapCongThucNhanhTTK, setIsNhapCongThucNhanhTTK] = useState(null);
  const [isSuaDonBanGiaoNhan, setIsSuaDonBanGiaoNhan] = useState(null);
  const [isCanhBaoBanGiaTrungBinh, setIsCanhBaoBanGiaTrungBinh] =
    useState(null);

  if (objDataStore.List.length > 0 && StoreID === "") {
    setStoreID(objDataStore.List[0].StoreID);
  }
  //lấy mặc định kho đầu tiên

  const [isNhapThueGTGT, setIsNhapThueGTGT] = useState(null);
  if (
    objConfigAll.List.length > 0 &&
    lamTron === null &&
    isNhapThueGTGT === null &&
    isNhapCongThucNhanhTTK === null &&
    isSuaDonBanGiaoNhan == null
  ) {
    const configKhongLamTron = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() === configs.sKey.Khonglamtrontien.toUpperCase()
    );
    setLamTron(true);
    if (
      typeof configKhongLamTron !== "undefined" &&
      configKhongLamTron != null
    ) {
      if (configKhongLamTron.Value === "1") {
        setLamTron(false);
      }
    }
    //
    const configNhapThue = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === configs.sKey.NhapThueSuat.toUpperCase()
    );

    setIsNhapThueGTGT(false);
    if (typeof configNhapThue !== "undefined" && configNhapThue != null) {
      if (configNhapThue.Value === "1") {
        setIsNhapThueGTGT(true);
      }
    }
    //
    const configIsCanhBaoBanGiaTrungBinh = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() ===
        configs.sKey.IsCanhBaoBanGiaTrungBinh.toUpperCase()
    );

    // setIsCanhBaoBanGiaTrungBinh(false);
    // if (
    //   typeof configIsCanhBaoBanGiaTrungBinh !== "undefined" &&
    //   configIsCanhBaoBanGiaTrungBinh != null
    // ) {
    //   if (configIsCanhBaoBanGiaTrungBinh.Value === "1") {
    //     setIsCanhBaoBanGiaTrungBinh(true);
    //   }
    // }
    //
    const configNhapCTN = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() ===
        configs.sKey.IsNhapCongThucNhanhTTK.toUpperCase()
    );

    setIsNhapCongThucNhanhTTK(false);
    if (typeof configNhapCTN !== "undefined" && configNhapCTN != null) {
      if (configNhapCTN.Value === "1") {
        setIsNhapCongThucNhanhTTK(true);
      }
    }

    const configSuaDonGiaoNhan = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() === configs.sKey.IsSuaDonBanGiaoNhan.toUpperCase()
    );

    setIsSuaDonBanGiaoNhan(false);
    if (
      typeof configSuaDonGiaoNhan !== "undefined" &&
      configSuaDonGiaoNhan != null
    ) {
      if (configSuaDonGiaoNhan.Value === "1") {
        setIsSuaDonBanGiaoNhan(true);
      }
    }
  }

  if (
    objConfigAll.List.length > 0 &&
    dataBanHang.ConfigSuaNgay == null &&
    dataBanHang.ConfigPhienBan == null &&
    dataBanHang.ConfigThueGTGT == null &&
    dataBanHang.ConfigCanhBaoDHQuaHan == null &&
    dataBanHang.ConfigMaPO == null &&
    dataBanHang.ConfigNhanVienKinhDoanh == null &&
    dataBanHang.ConfigChuaGiCong == null &&
    dataBanHang.ConfigTruKhoGiaCong == null &&
    dataBanHang.configThuocTinhKhac === "0" &&
    dataBanHang.ConfigBanBuonBanLe == null &&
    dataBanHang.ConfigTiTrong == null &&
    dataBanHang.configChietKhau == null &&
    dataBanHang.ConfigBanAm == null &&
    dataBanHang.ConfigTruKhoVaoNgayTao == null &&
    dataBanHang.ConfigSuaSanPhamBanHang == null &&
    dataBanHang.ConfigShowTTKTheoNhom == null &&
    dataBanHang.ConfigMauHoaDon == "" &&
    dataBanHang.ConfigThanhToanDHCu == null &&
    dataBanHang.ConfigLamTronTien == null &&
    dataBanHang.ConfigCongThucCK == null &&
    dataBanHang.ConfigPhanBoCongNoTheoSanPham == null
  ) {
    const thongtin = { ...dataBanHang };
    const configDate = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() ===
        configs.sKey.AUTO_EDIT_DATETIME_TRANSACTION.toUpperCase()
    );
    thongtin.ConfigSuaNgay = false;
    if (configDate != null) {
      if (configDate.Value === "1") {
        thongtin.ConfigSuaNgay = true;
      }
    }
    //
    var sCheckVersion = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === configs.sKey.KeyPhienBan.toUpperCase()
    );
    if (
      sCheckVersion != null &&
      sCheckVersion.Value.toUpperCase() ===
      configs.sKey.DoanhNghiepFull.toUpperCase()
    ) {
      thongtin.ConfigPhienBan = true;
    } else {
      thongtin.ConfigPhienBan = false;
    }
    var sGoiPhanMem = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === configs.sKey.GoiPhanMem.toUpperCase()
    );
    if (typeof sGoiPhanMem != "undefined" && sGoiPhanMem.Value !== "1") {
      setGoiPhanMem(sGoiPhanMem.Value);
    }
    // console.log("sGoiPhanMem", sGoiPhanMem);
    // console.log("sGoiPhanMem", GoiPhanMem);

    var sHienthiAutotrukhogiacong = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() ===
        configs.sKey.HienthiAutotrukhogiacong.toUpperCase()
    );
    if (
      typeof sHienthiAutotrukhogiacong != "undefined" &&
      sHienthiAutotrukhogiacong.Value === "1"
    ) {
      setHienthiAutotrukhogiacong(sHienthiAutotrukhogiacong.Value);
    }

    //
    var configHoaDonGTGT = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() === configs.sKey.isShowHoaDonGTGT.toUpperCase()
    );

    thongtin.ConfigThueGTGT = false;
    if (configHoaDonGTGT != null) {
      if (configHoaDonGTGT.Value === "1") {
        thongtin.IsLayHoaDon = true;
        thongtin.ConfigThueGTGT = true;
        thongtin.isShowThueGTGT = true;
      }
    }
    //
    var configCanhBaoDH = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() ===
        configs.sKey.isShowCanhBaoDonHangQuaHanKhiBanHang.toUpperCase()
    );
    thongtin.ConfigCanhBaoDHQuaHan = false;
    if (configCanhBaoDH != null) {
      if (configCanhBaoDH.Value === "1") {
        thongtin.ConfigCanhBaoDHQuaHan = true;
      }
    }
    //
    const configPO = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === configs.sKey.ConfigMaPO.toUpperCase()
    );
    thongtin.ConfigMaPO = false;
    if (typeof configPO !== "undefined" && configPO != null) {
      if (configPO.Value === "1") {
        thongtin.ConfigMaPO = true;
      }
    }
    //
    const configNVKD = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() ===
        configs.sKey.shownhanvienkinhdoanh.toUpperCase()
    );
    thongtin.ConfigNhanVienKinhDoanh = false;
    if (typeof configNVKD !== "undefined" && configNVKD != null) {
      if (configNVKD.Value === "1") {
        thongtin.ConfigNhanVienKinhDoanh = true;
      }
    }
    //
    const sConfigChuaGiaCong = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === configs.sKey.isChuagiacong.toUpperCase()
    );
    thongtin.ConfigChuaGiCong = false;
    if (
      typeof sConfigChuaGiaCong !== "undefined" &&
      sConfigChuaGiaCong != null
    ) {
      if (sConfigChuaGiaCong.Value === "1") {
        thongtin.ConfigChuaGiCong = true;
      }
    }
    //
    const sConfigTruKhoGiaCong = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() === configs.sKey.AutoTruKhoGiaCong.toUpperCase()
    );
    thongtin.ConfigTruKhoGiaCong = false;
    if (
      typeof sConfigTruKhoGiaCong !== "undefined" &&
      sConfigTruKhoGiaCong != null
    ) {
      if (sConfigTruKhoGiaCong.Value === "1") {
        thongtin.ConfigTruKhoGiaCong = true;
      }
    }
    //
    var sconfigThuocTinhKhac = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === configs.sKey.IsChonTTK.toUpperCase()
    );
    if (
      typeof sconfigThuocTinhKhac !== "undefined" &&
      sconfigThuocTinhKhac != null
    ) {
      thongtin.configThuocTinhKhac = sconfigThuocTinhKhac.Value;
    }
    //
    const sConfigBanBuon = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === configs.sKey.IsBanBuonBanLe.toUpperCase()
    );
    thongtin.ConfigBanBuonBanLe = false;
    if (typeof sConfigBanBuon !== "undefined" && sConfigBanBuon != null) {
      if (sConfigBanBuon.Value === "1") {
        thongtin.ConfigBanBuonBanLe = true;
      }
    }
    //
    const sConfigTiTrong = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === configs.sKey.HienThiTiTrong.toUpperCase()
    );
    thongtin.ConfigTiTrong = false;
    if (typeof sConfigTiTrong !== "undefined" && sConfigTiTrong != null) {
      if (sConfigTiTrong.Value === "1") {
        thongtin.ConfigTiTrong = true;
      }
    }
    //
    var sconfigChietKhau = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === configs.sKey.IsChietKhauSP.toUpperCase()
    );
    if (typeof sconfigChietKhau !== "undefined" && sconfigChietKhau != null) {
      thongtin.configChietKhau = sconfigChietKhau.Value;
    }
    //
    const sConfigBanAm = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === configs.sKey.IsChoPhepBanAm.toUpperCase()
    );
    thongtin.ConfigBanAm = false;
    if (typeof sConfigBanAm !== "undefined" && sConfigBanAm != null) {
      if (sConfigBanAm.Value === "1") {
        thongtin.ConfigBanAm = true;
      }
    }
    //
    const sConfigTruKhoVaoNgayTao = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() === configs.sKey.TruKhoVaoNgayTao.toUpperCase()
    );
    thongtin.ConfigTruKhoVaoNgayTao = false;
    if (
      typeof sConfigTruKhoVaoNgayTao !== "undefined" &&
      sConfigTruKhoVaoNgayTao != null
    ) {
      if (sConfigTruKhoVaoNgayTao.Value === "1") {
        thongtin.ConfigTruKhoVaoNgayTao = true;
      }
    }
    //
    const sConfigSuaSanPhamBanHang = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() === configs.sKey.SuaSanPhamBanHang.toUpperCase()
    );
    thongtin.ConfigSuaSanPhamBanHang = false;
    if (
      typeof sConfigSuaSanPhamBanHang !== "undefined" &&
      sConfigSuaSanPhamBanHang != null
    ) {
      if (sConfigSuaSanPhamBanHang.Value === "1") {
        thongtin.ConfigSuaSanPhamBanHang = true;
      }
    }
    //
    const sConfigShowTTKTheoNhom = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() ===
        configs.sKey.SHOW_TONGTHUOCTINHKHAC_THEONHOM.toUpperCase()
    );
    thongtin.ConfigShowTTKTheoNhom = false;
    if (
      typeof sConfigShowTTKTheoNhom !== "undefined" &&
      sConfigShowTTKTheoNhom != null
    ) {
      if (sConfigShowTTKTheoNhom.Value === "1") {
        thongtin.ConfigShowTTKTheoNhom = true;
      }
    }
    //
    var sconfigMauHoaDonPrint = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === configs.sKey.MauHoaDonPrint.toUpperCase()
    );
    if (
      typeof sconfigMauHoaDonPrint !== "undefined" &&
      sconfigMauHoaDonPrint != null
    ) {
      thongtin.ConfigMauHoaDon = sconfigMauHoaDonPrint.Value;
    }
    //
    const sconfigThanhToanDHCu = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() ===
        configs.sKey.IsPhanBoCongNoKhiTaoPhieuThu.toUpperCase()
    );
    thongtin.ConfigThanhToanDHCu = false;
    if (
      typeof sconfigThanhToanDHCu !== "undefined" &&
      sconfigThanhToanDHCu != null
    ) {
      if (sconfigThanhToanDHCu.Value === "1") {
        thongtin.ConfigThanhToanDHCu = true;
      }
    }
    //
    const sconfigLamTronTien = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() === configs.sKey.Khonglamtrontien.toUpperCase()
    );
    thongtin.ConfigLamTronTien = true;
    if (
      typeof sconfigLamTronTien !== "undefined" &&
      sconfigLamTronTien != null
    ) {
      if (sconfigLamTronTien.Value === "1") {
        thongtin.ConfigLamTronTien = false;
      }
    }

    //
    var sconfigPhanBoCongNoTheoSanPham = objConfigAll.List.find(
      (e) => e.KeyID.toUpperCase() === "IsPhanBoCongNoTheoSanPham".toUpperCase()
    );

    thongtin.ConfigPhanBoCongNoTheoSanPham = false;
    if (
      typeof sconfigPhanBoCongNoTheoSanPham !== "undefined" &&
      sconfigPhanBoCongNoTheoSanPham != null
    ) {
      if (sconfigPhanBoCongNoTheoSanPham.Value === "1") {
        thongtin.ConfigPhanBoCongNoTheoSanPham = true;
      }
    }

    //
    var sconfigCongThucCK = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() === configs.sKey.ConfigCkCongThuc.toUpperCase()
    );

    thongtin.ConfigCongThucCK = false;
    if (typeof sconfigCongThucCK !== "undefined" && sconfigCongThucCK != null) {
      if (sconfigCongThucCK.Value === "1") {
        thongtin.ConfigCongThucCK = true;
      }
    }
    setDataBanHang(thongtin);
  }


  if (objConfigAll.List.length > 0 && (dataBanHang.configDateChiTietDH == null || dataBanHang.configDateChiTietDH == undefined)) {
    const thongtin = { ...dataBanHang };
    thongtin.configDateChiTietDH = false;
    const sConfigDateChiTietDH = objConfigAll.List.find(
      (e) =>
        e.KeyID.toUpperCase() ===
        configs.sKey.showTimeChiTietDonHang.toUpperCase()
    );
    if (
      typeof sConfigDateChiTietDH !== "undefined" &&
      sConfigDateChiTietDH != null
    ) {
      if (sConfigDateChiTietDH.Value === "1") {
        thongtin.configDateChiTietDH = true;
      }
    }
    setDataBanHang(thongtin);
  }

  const onChangeDate1 = (field) => (evt) => {
    var current = null;
    const baseDate = new Date(evt); // dùng ngày chọn
    debugger;
    baseDate.setDate(
      baseDate.getDate()
    );
    const newDate = moment(baseDate).format("YYYY-MM-DD"); // Sử dụng baseDate trực tiếp
    current = new Date(newDate);


    // var date = formatDayMonth(dataBanHang.CreatedTime);
    var date1 = new Date(evt);
    var mm = dataBanHang.NgayDuKienGiao.getMonth() + 1; // getMonth() is zero-based
    var dd = dataBanHang.NgayDuKienGiao.getDate();
    var date00 =
      [
        dataBanHang.NgayDuKienGiao.getFullYear(),
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
      ].join("-") + " 00:00:00";
    var date23 =
      [
        dataBanHang.NgayDuKienGiao.getFullYear(),
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
      ].join("-") + " 23:59:59";
    var date2 = new Date(dataBanHang.NgayDuKienGiao);
    var date3 = new Date(date00);

    setDataBanHang({
      ...dataBanHang,
      NgayDuKienGiao: evt,
    });

  };

  const onChangeDate = (field) => (evt) => {
    var current = null;
    const baseDate = new Date(evt); // dùng ngày chọn
    debugger;
    baseDate.setDate(
      baseDate.getDate() + convertToNumber(dataBanHang.SoNgayNo)
    );
    const newDate = moment(baseDate).format("YYYY-MM-DD"); // Sử dụng baseDate trực tiếp
    current = new Date(newDate);


    // var date = formatDayMonth(dataBanHang.CreatedTime);
    var date1 = new Date(evt);
    var mm = dataBanHang.CreatedTime.getMonth() + 1; // getMonth() is zero-based
    var dd = dataBanHang.CreatedTime.getDate();
    var date00 =
      [
        dataBanHang.CreatedTime.getFullYear(),
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
      ].join("-") + " 00:00:00";
    var date23 =
      [
        dataBanHang.CreatedTime.getFullYear(),
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
      ].join("-") + " 23:59:59";
    var date2 = new Date(dataBanHang.CreatedTime);
    var date3 = new Date(date00);

    setDataBanHang({
      ...dataBanHang,
      CreatedTime: evt,
    });

  };

  //đối tác khách lẻ và thuế GTGT
  const handleChange = (nextChecked) => {
    const thongtin = { ...dataBanHang };
    thongtin.IsLayHoaDon = nextChecked;
    if (nextChecked === true) {
      thongtin.isShowThueGTGT = true;
    } else {
      thongtin.isShowThueGTGT = false;
    }
    setDataBanHang(thongtin);
  };

  const handleChange1 = (nextChecked) => {
    const thongtin = { ...dataBanHang };
    thongtin.IsAutoTruKho = nextChecked;

    setDataBanHang(thongtin);
  };

  const TinhTienThue = () => {
    const thongtin = { ...dataBanHang };
    if (thongtin.lstChiTiet.length > 0) {
      var lstNew = thongtin.lstChiTiet.map((cate, i) => { });
    }
  };
  // const onChangeGTGT = (field, e) => updateStateThongTinGTGT(field, e);
  // const updateStateThongTinGTGT = (field, e) => {
  //   const thongtin = { ...dataBanHang };
  //   thongtin.ThueGTGT = convertToNumber(e.target.value);
  //   setDataBanHang(thongtin);
  //   if (thongtin.lstChiTiet.length > 0) {
  //     var lstNew = thongtin.lstChiTiet.map((cate, i) => {
  //       cate.ThueGTGT = convertToNumber(e.target.value);
  //       const newGTGT = thongtin.ChietKhau / cate.tongNew;

  //       const newPrice = convertToNumber(cate.ExportPrice) - newGTGT;
  //       const GTGT = convertToNumber(e.target.value) / 100;
  //       cate.PriceGTGT = newPrice * GTGT * cate.Tong;

  //       thongtin.TotalAmountThueGTGT = numeral(
  //         CustomerParseFloat(thongtin.TotalAmountThueGTGT) +
  //           CustomerParseFloat(cate.PriceGTGT)
  //       ).format("0");

  //       thongtin.TotalAmountNew =
  //         CustomerParseFloat(thongtin.TotalAmount) +
  //         CustomerParseFloat(thongtin.TotalAmountThueGTGT);
  //       //
  //       return cate;
  //     });
  //     thongtin.lstChiTiet = lstNew;
  //     setDataBanHang(thongtin);
  //   }
  // };

  const result = listNhomSP.reduce(
    (r, { Values, TenNhomSPCha, IdNhomSPCha }) => {
      var temp = r.find((o) => o.IdNhomSPCha === IdNhomSPCha);
      if (!temp) {
        r.push({ Values, TenNhomSPCha, IdNhomSPCha });
      } else {
        temp.Values += Values;
      }
      return r;
    },
    []
  );
  //End cộng gộp giá trị và gộp object nếu cùng id

  const onSubmit = () => {
    setValueSanPham(0);
    const value = { ...categoryNow };
    const value1 = { ...dataBanHang };
    var dateDatHang = formatDayMonth(value1.CreatedTime);
    var dateNgayGiaoDuKien = formatDayMonth(value1.NgayDuKienGiao);
    if (categoryNow.SLDonViBan == "") {
      pushNotification(
        "Các thông tin dữ liệu phải điền đầy đủ.",
        "error",
        "TOP_RIGHT",
        2000
      );
      return;
    } else if (categoryNow.IdDonViXuatView == 0) {
      pushNotification("Chưa chọn sản phẩm", "error", "TOP_RIGHT", 2000);
      return;
    } else if (categoryNow.SLDonViBan == 0) {
      pushNotification("Số lượng bán lớn hơn 0", "error", "TOP_RIGHT", 2000);
      return;
    } else if (
      typeof categoryNow.CategoryID != "undefined" &&
      categoryNow.Attributes.length == 0 &&
      categoryNow.TenDonViXuat != null
    ) {
      if (categoryNow.SLDonViBan == "" && categoryNow.Attributes.length === 0) {
        pushNotification(
          "Các thông tin dữ liệu phải điền đầy đủ.",
          "error",
          "TOP_RIGHT",
          2000
        );
        return;
      }
    }
    //

    if (
      isCanhBaoBanGiaTrungBinh &&
      categoryNow.ExportPrice < categoryNow.GiaTB
    ) {
      pushNotification(
        "Giá bán không được nhỏ hơn giá vốn trung bình.",
        "error",
        "TOP_RIGHT",
        2000
      );
      return;
    }

    if (dataBanHang.isShowThueGTGT && dataBanHang.lstChiTiet.length > 0) {
      const isFound = dataBanHang.lstChiTiet.some((element) => {
        if (categoryNow.ThueGTGT.toString() !== element.ThueGTGT.toString()) {
          if (
            element.OptionID === categoryNow.OptionID &&
            element.CategoryID === categoryNow.CategoryID
          )
            return true;
        }

        return false;
      });
      if (isFound === true) {
        pushNotification(
          "Cùng sản phẩm trong 1 đơn hàng phải có cùng 1 loại thuế suất",
          "error",
          "TOP_RIGHT",
          2000
        );
        return;
      }
    }
    const valueJson = JSON.stringify(value);
    var valueGet = JSON.parse(valueJson);
    if (
      dataBanHang.ConfigBanAm === false &&
      categoryNow.CategorieType == "HangHoa"
    ) {
      //
      var tong = 0;
      var strAttribute = "";
      var valueAttribute = 0;
      var AttributeDonVi = "";
      var sDonVi = "";
      var checkAttr = false;
      valueGet.ValueOfUnitForExportPrice = valueGet.SLDonViBan;
      valueGet.UnitForExportPrice = valueGet.IdDonViXuatView;
      valueGet.ValueOfUnitForExportPrice = (
        valueGet.ValueOfUnitForExportPrice + ""
      )
        .replace(/,/g, "")
        .replace(/-/g, "");
      if (valueGet.Attributes.length > 0) {
        var attrMain = valueGet.Attributes.find(
          (e) => e.AttributeID === valueGet.IdDonViXuat
        );
        if (
          typeof valueGet.LstDonViNhap != "undefined" &&
          typeof attrMain != "undefined"
        ) {
          valueAttribute = attrMain.Values;
          var attrChon = valueGet.LstDonViNhap.find(
            (e) => e.AttributeID == valueGet.IdDonViXuatView
          );
          if (attrChon != null) {
            attrChon.Values = valueGet.ValueOfUnitForExportPrice;
            attrChon.isCheck = true;
            if (attrMain != null) {
              let index = 0;
              valueGet.Attributes.map((Attribute, i) => {
                if (Attribute.AttributeID == valueGet.IdDonViXuat) {
                  index = i;
                }
              });
              valueGet.ValueOfUnitForExportPrice = attrMain.Values;
              valueGet.Attributes.splice(index, 1);
              valueGet.Attributes.push(attrChon);
            }
          }
        }
        if (valueAttribute == 0) {
          valueGet.Attributes.map((Attribute, i) => {
            if (Attribute.isCheck) {
              valueAttribute =
                (Attribute.Values * Attribute.RatioMain) /
                Attribute.RatioDifferent;
              AttributeDonVi = Attribute.Name;
            }
          });
        }
      }
      if (valueAttribute != 0) {
        sDonVi = AttributeDonVi;
        if (valueGet.ShowQuantity) {
          tong = valueAttribute * CustomerParseFloat(valueGet.Quantity);
        } else {
          tong = valueAttribute;
        }
      } else {
        if (valueGet.RateForSale == 0) {
          valueGet.RateForSale = 1;
        }
        if (valueGet.ShowQuantity) {
          tong =
            CustomerParseFloat(valueGet.ValueOfUnitForExportPrice) *
            CustomerParseFloat(valueGet.Quantity) *
            valueGet.RateForSale;
        } else {
          tong =
            CustomerParseFloat(valueGet.ValueOfUnitForExportPrice) *
            valueGet.RateForSale;
        }
      }

      tong = CustomerParseFloat(numeral(tong).format("0.[0000]"));
      let thucban =
        CustomerParseFloat(valueGet.ValueOfUnitForExportPrice) *
        CustomerParseFloat(valueGet.Quantity);
      thucban = CustomerParseFloat(numeral(thucban).format("0.[0000]"));
      if (thucban > valueGet.SLTonThucTe) {
        pushNotification(
          "Trong kho không đủ số lượng để bán",
          "error",
          "TOP_RIGHT",
          2000
        );
        return;
      }
    }
    //

    //
    let sum = 0;
    let itemNew = {};
    if (value.Attributes.length > 0 && value.IdNhomSPCha !== 0) {
      sum = value.Attributes.reduce(function (prev, current) {
        return (prev += convertToNumber(current.Values));
      }, 0);
      itemNew.Values = sum;
      itemNew.TenNhomSPCha = value.TenNhomSPCha;
      itemNew.IdNhomSPCha = value.IdNhomSPCha;
      listNhomSP.push({ ...itemNew });
      // setTenNhomSP(value.TenNhomSPCha);
    }
    // categoryNow.ThueGTGT = dataBanHang.ThueGTGTChung;
    const lstChiTiet = [];
    var str = categoryNow.SLDonViBan.replace(/\(/g, "").replace(/\)/g, "");
    var arrSanPham = str.split("+");
    // chỗ này nếu nhập kiểu (3+4)*2 thì vẫn không cần hiểu là *1 cạnh các số

    if (categoryNow.SLDonViBan.indexOf("(") > -1) {
      arrSanPham = str.split("+");
    } else {
      var parts = str.split("+");
      var processedParts = parts.map(function (part) {
        part = part.trim();
        if (part.indexOf("*") === -1) {
          return part + "*1";
        }
        return part;
      });
      arrSanPham = processedParts;
    }
    if (arrSanPham.length > 1 || categoryNow.SLDonViBan.indexOf("*") > -1) {
      arrSanPham.map((item, index) => {
        if (item.indexOf("*") > -1) {
          var nhan = item.split("*");
          if (nhan[0] === "" || nhan[1] === "") {
            pushNotification("Sai công thức nhập.", "error", "TOP_RIGHT", 2000);
            return;
          }
          if (
            nhan[0].toString().split(".").length - 2 > 0 ||
            nhan[1].toString().split(".").length - 2 > 0
          ) {
            pushNotification("Sai công thức nhập.", "error", "TOP_RIGHT", 2000);
            return;
          }
          if (nhan[1].toString().includes(".")) {
            pushNotification("Sai công thức nhập.", "error", "TOP_RIGHT", 2000);
            return;
          }
          categoryNow.SLDonViBan = nhan[0];
          categoryNow.Quantity = nhan[1];
          lstChiTiet.push({ ...categoryNow });
        } else {
          for (var i = index + 1; i <= arrSanPham.length; i++) {
            if (arrSanPham[i].indexOf("*") > -1) {
              var nhan = arrSanPham[i].split("*");
              if (
                item.toString().split(".").length - 2 > 0 ||
                nhan[1].toString().split(".").length - 2 > 0
              ) {
                pushNotification(
                  "Sai công thức nhập.",
                  "error",
                  "TOP_RIGHT",
                  2000
                );
                return;
              }
              if (nhan[1].toString().includes(".")) {
                pushNotification(
                  "Sai công thức nhập.",
                  "error",
                  "TOP_RIGHT",
                  2000
                );
                return;
              }
              categoryNow.SLDonViBan = item;
              categoryNow.Quantity = nhan[1];
              if (arrSanPham[i] === "" || nhan[1] === "") {
                pushNotification(
                  "Sai công thức nhập.",
                  "error",
                  "TOP_RIGHT",
                  2000
                );
                return;
              }
              lstChiTiet.push({ ...categoryNow });
              return;
            }
          }
        }
      });
      lstChiTiet.map((item, index) => {
        item.ValueOfUnitForImportPrice = item.SLDonViNhap;
        item.ValueOfUnitForExportPrice = item.SLDonViBan;
        // item.Price = item.ExportPrice;
        // let temp = categoryNow.ExportPrice;
        // categoryNow.Price = categoryNow.GiaGoc;
        // categoryNow.GiaGoc = temp;
        item.UnitForImportPrice = item.IdDonViNhapView;
        item.UnitForExportPrice = item.IdDonViXuatView;
        // Cập nhật lại values của attribute khi phân tách xong công thức nhập nhanh
        if (item.Attributes.length > 0) {
          const newData = item.Attributes.map((row, i) => {
            let itemRow = { ...row };
            itemRow.Values = numeral(
              (row.RatioDifferentView / row.RatioMainView) * item.SLDonViBan
            )
              .format("0.[0000]")
              .doidau();
            itemRow.RatioDifferentNew = 0;
            return itemRow;
          });
          item.Attributes = [...newData];
        }
        //Bán SP TTK
        if (categoryNow.LstDonViNhap.length > 0) {
          const isFound = categoryNow.LstDonViNhap.some((element) => {
            if (element.IsBanTTK === true) return true;
            return false;
          });
          if (isFound === true && dataBanHang.configThuocTinhKhac === "1") {
            let valueNew = categoryNow.Attributes;
            categoryNow.AttributesNew2 = valueNew.map((itemNew, indexNew) => {
              categoryNow.ValueOfUnitForExportPrice = itemNew.Values;
              return itemNew;
            });
            categoryNow.Attributes = categoryNow.AttributesNew.map(
              (itemAtt, indexAtt) => {
                if (itemAtt.IsBanTTK) {
                  itemAtt.Values = categoryNow.SLDonViBan;
                } else {
                  var att = categoryNow.Attributes.find(
                    (e) => e.AttributeID == itemAtt.AttributeID
                  );
                  itemAtt.Values = CustomerParseFloat(att.Values);
                }
                return itemAtt;
              }
            );
          }
        }

        //End bán SP TTK
        // item.CongThucSanPham = item.objCongThucSanPham;
        dataBanHang.lstChiTiet.push(item);
      });
    } else {
      categoryNow.ValueOfUnitForImportPrice = categoryNow.SLDonViNhap;
      categoryNow.ValueOfUnitForExportPrice = categoryNow.SLDonViBan;
      categoryNow.UnitForImportPrice = categoryNow.IdDonViNhapView;
      categoryNow.UnitForExportPrice = categoryNow.IdDonViXuatView;

      // let temp = categoryNow.ExportPrice;
      // categoryNow.Price = categoryNow.GiaGoc;
      // categoryNow.GiaGoc = temp;
      //Bán SP TTK
      if (categoryNow.LstDonViNhap.length > 0) {
        const isFound = categoryNow.LstDonViNhap.some((element) => {
          if (element.IsBanTTK === true) return true;
          return false;
        });
        if (isFound === true && dataBanHang.configThuocTinhKhac === "1") {
          let valueNew = categoryNow.Attributes;
          categoryNow.AttributesNew2 = valueNew.map((itemNew, indexNew) => {
            categoryNow.ValueOfUnitForExportPrice = itemNew.Values;
            return itemNew;
          });
          categoryNow.Attributes = categoryNow.AttributesNew.map(
            (itemAtt, indexAtt) => {
              if (itemAtt.IsBanTTK) {
                itemAtt.Values = categoryNow.SLDonViBan;
              } else {
                var att = categoryNow.Attributes.find(
                  (e) => e.AttributeID == itemAtt.AttributeID
                );
                itemAtt.Values = CustomerParseFloat(att.Values);
              }
              return itemAtt;
            }
          );
        }
      }

      //End bán SP TTK

      // categoryNow.CongThucSanPham = categoryNow.objCongThucSanPham;
      dataBanHang.lstChiTiet.push({ ...categoryNow });
    }

    setCategoryNow(constCategoryNow);
    setDataBanHang(dataBanHang);
    setValue("");
    // TinhTong();
    setFocusTenSanPham(true);
    HienThiChietKhau();
  };

  const HienThiChietKhau = () => {
    const obj = { ...dataBanHang };
    var lstTemp = [];
    // if (obj.ChietKhauNhom.listGroupCatNames.length > 0) {
    // }
    obj.lstChiTiet.map((category, index) => {
      if (category.Attributes.length == 0) {
        return null;
      }
      var ChietKhauTheoKG = category.Attributes.find(
        (e) => e.Name.toLowerCase().trim() === "kg"
      );
      if (typeof ChietKhauTheoKG === "undefined") {
        return null;
      }
      var SoTienChietKhau = 0;
      if (
        typeof listChietKhauNhomKH.listGroupCatNames !== "undefined" &&
        listChietKhauNhomKH.listGroupCatNames.length > 0
      ) {
        var ChietKhauTheoKH = listChietKhauNhomKH.listGroupCatNames.find(
          (e) => e.GroupCatID === category.IdNhomSPCha
        );
        if (typeof ChietKhauTheoKH !== "undefined") {
          SoTienChietKhau = ChietKhauTheoKH.ChietKhau;
          if (lstTemp.length == 0) {
            var item = {
              SoLuong: ChietKhauTheoKG.Values,
              TenNhomSPCha: category.TenNhomSPCha,
              IdNhomSPCha: category.IdNhomSPCha,
              TienChietKhau: SoTienChietKhau,
            };
            lstTemp.push(item);
          } else {
            var listNewCK = lstTemp.find(
              (e) => e.IdNhomSPCha === category.IdNhomSPCha
            );

            if (typeof listNewCK != "undefined" && listNewCK.SoLuong) {
              lstTemp.map((nhom, index1) => {
                if (nhom.IdNhomSPCha === listNewCK.IdNhomSPCha) {
                  nhom.SoLuong =
                    convertToNumber(listNewCK.SoLuong) +
                    convertToNumber(ChietKhauTheoKG.Values);
                }
                return nhom;
              });
            } else {
              var itemNew = {
                SoLuong: ChietKhauTheoKG.Values,
                TenNhomSPCha: category.TenNhomSPCha,
                IdNhomSPCha: category.IdNhomSPCha,
                TienChietKhau: SoTienChietKhau,
              };
              lstTemp.push(itemNew);
            }

            // console.log(listNew, "11111111111111");
          }
        }
      } else {
      }
    });
    setListChietKhauNhom(lstTemp);
  };
  const HienThiChietKhauCoBien = (ChietKhauNhom) => {
    const obj = { ...dataBanHang };
    var lstTemp = [];
    // if (obj.ChietKhauNhom.listGroupCatNames.length > 0) {
    // }
    obj.lstChiTiet.map((category, index) => {
      if (category.Attributes.length == 0) {
        return null;
      }
      var ChietKhauTheoKG = category.Attributes.find(
        (e) => e.Name.toLowerCase().trim() === "kg"
      );
      if (typeof ChietKhauTheoKG === "undefined") {
        return null;
      }
      var SoTienChietKhau = 0;
      if (
        typeof ChietKhauNhom.listGroupCatNames !== "undefined" &&
        ChietKhauNhom.listGroupCatNames.length > 0
      ) {
        var ChietKhauTheoKH = ChietKhauNhom.listGroupCatNames.find(
          (e) => e.GroupCatID === category.IdNhomSPCha
        );
        if (typeof ChietKhauTheoKH !== "undefined") {
          SoTienChietKhau = ChietKhauTheoKH.ChietKhau;
          if (lstTemp.length == 0) {
            var item = {
              SoLuong: ChietKhauTheoKG.Values,
              TenNhomSPCha: category.TenNhomSPCha,
              IdNhomSPCha: category.IdNhomSPCha,
              TienChietKhau: SoTienChietKhau,
            };
            lstTemp.push(item);
          } else {
            var listNewCK = lstTemp.find(
              (e) => e.IdNhomSPCha === category.IdNhomSPCha
            );

            if (typeof listNewCK != "undefined" && listNewCK.SoLuong) {
              lstTemp.map((nhom, index1) => {
                if (nhom.IdNhomSPCha === listNewCK.IdNhomSPCha) {
                  nhom.SoLuong =
                    convertToNumber(listNewCK.SoLuong) +
                    convertToNumber(ChietKhauTheoKG.Values);
                }
                return nhom;
              });
            } else {
              var itemNew = {
                SoLuong: ChietKhauTheoKG.Values,
                TenNhomSPCha: category.TenNhomSPCha,
                IdNhomSPCha: category.IdNhomSPCha,
                TienChietKhau: SoTienChietKhau,
              };
              lstTemp.push(itemNew);
            }
          }
        }
      } else {
      }
    });
    setListChietKhauNhom(lstTemp);
  };

  const updateTienCKNhom = (soTien, IdNhomSPCha) => {
    const obj = { ...dataBanHang };
    var lstNew = obj.lstChiTiet.map((category, index) => {
      if (category.IdNhomSPCha === IdNhomSPCha) {
        category.ChietKhau_Nhom = soTien;
      }
      return category;
    });
    obj.lstChiTiet = lstNew;
    setDataBanHang(obj);
  };

  const [listChiNhanh, setListChiNhanh] = useState([]);
  const [diachichinhanh, setDiaChiChiNhanh] = useState("");
  const [sodienthoaichinhanh, setSoDienThoaiChiNhanh] = useState("");
  useEffect(() => {
    if (dataBanHang.BranchID == 0) {
      ChiNhanhApi.listChiNhanhNoTong({ sUserName: "" }).then((response) => {
        if (response.status === 200) {
          setListChiNhanh(response.data.List);
          if (response.data.List.length > 0) {
            let enBranch = response.data.List[0];
            const thongtin = { ...dataBanHang };
            thongtin.BranchID = enBranch.BranchID;
            setDataBanHang(thongtin);
            setDiaChiChiNhanh(enBranch.BranchAddress);
            setSoDienThoaiChiNhanh(enBranch.BranchPhone);
          }
        }
      });
    }
  }, [dataBanHang.BranchID]);


  const selectChiNhanh = () => {
    var lstChiNhanh = listChiNhanh.map((store, index) => {
      const { BranchID, BranchName } = store;
      return <option value={BranchID}>{BranchName}</option>;
    });
    return lstChiNhanh;
  };

  const onChangeText1 = (field, e) => updateStateThongTin1(field, e);
  const updateStateThongTin1 = (field, e) => {
    const thongtin = { ...dataBanHang };
    const value = e.target.validity.valid ? e.target.value : thongtin[field];
    thongtin[field] = value;
    var enChiNhanh = listChiNhanh.find(
      (item) => item.BranchID === convertToNumber(value)
    );

    if (typeof enChiNhanh !== "undefined") {
      setDiaChiChiNhanh(enChiNhanh.BranchAddress);
      setSoDienThoaiChiNhanh(enChiNhanh.BranchPhone);
    }
    setDataBanHang(thongtin);
  };

  const [loadding, setLoadding] = useState(false);
  return (
    <LayoutNew
      isProgress={loadding}
      isShowMenuShow={() => setIsShowMenu(true)}
      isShowMenuHide={() => setIsShowMenu(false)}
    >
      <>
        <div className="bg-main-content bg-add-content">
          <div className="header-main">
            <div className="row">
              <div className="col-sm-6">
                <TitlePage titlePage="Đặt hàng" IconTitle={mdiPlus} />
              </div>
              <div className="col-sm-6"></div>
            </div>
          </div>
          {/* <!--1--> */}
          <div class="form-add1">
            <div class="row-form">
              <div className="row">
                <div className="col-md-4">
                  <div class="form-group  align-centerNew  ">
                    <div className="form-new-input-left">
                      <label class="col-form-label">Chi nhánh đặt hàng</label>
                      <select
                        class="form-control "
                        value={dataBanHang.BranchID}
                        onChange={(e) => onChangeText1("BranchID", e)}
                      >
                        {selectChiNhanh()}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  {sodienthoaichinhanh != '' && (
                    <>{"Điện thoại: " + sodienthoaichinhanh}</>
                  )}
                  <br />
                  {diachichinhanh != '' && (
                    <>{"Địa chỉ: " + diachichinhanh}</>
                  )}
                </div>
              </div>
            </div>
            <div class="row-form">
              <div className="row">
                <div className="col-md-4">
                  <h2 class="title-detail-new">
                    <img src={iconDate} alt="" />
                    Ngày tạo đơn
                  </h2>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <DateTimePicker
                          format={"DD/MM/YYYY"}
                          time={false}
                          culture="vi"
                          value={dataBanHang.CreatedTime}
                          onChange={onChangeDate("CreatedTime")}
                          // disabled={
                          //   dataBanHang.ConfigSuaNgay !== true
                          //     ? true
                          //     : disEditAll
                          // }
                          disabled={true}
                          open={isOpen}
                          onFocus={() => setIsOpen("date")}
                          onBlur={() => setIsOpen(false)}
                          onSelect={() => setIsOpen(false)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <h2 class="title-detail-new">
                    <img src={iconDate} alt="" />
                    Ngày nhận hàng dự kiến
                  </h2>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <DateTimePicker
                          format={"DD/MM/YYYY"}
                          time={false}
                          culture="vi"
                          value={dataBanHang.NgayDuKienGiao}
                          onChange={onChangeDate1("NgayDuKienGiao")}
                          disabled={disEditAll}
                          open={isOpen1}
                          onFocus={() => setIsOpen1("date")}
                          onBlur={() => setIsOpen1(false)}
                          onSelect={() => setIsOpen1(false)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row-form">
              <ThongTinKhachHang
                isShowTinhThanh={isShowTinhThanh}
                dataBanHang={dataBanHang}
                setDataBanHang={setDataBanHang}
                roleHanThanhToan={roleHanThanhToan}
                DHQuaHanThanhToan={DHQuaHanThanhToan}
                setDHQuaHanThanhToan={setDHQuaHanThanhToan}
                activePage={activePage}
                setPageActive={setPageActive}
                disEditKH={disEditKH}
                listNVKD={listNVKD}
                setListNVKD={setListNVKD}
                HienThiChietKhau={HienThiChietKhau}
                HienThiChietKhauCoBien={HienThiChietKhauCoBien}
                setListChietKhauNhomKH={setListChietKhauNhomKH}
                updateTienCKNhom={updateTienCKNhom}
                setFocusKho={setFocusKho}
                setDisEditKH={setDisEditKH}
                EditID={sCode}
                isShowNVKDNew={isShowNVKDNew}
                disEditAll={disEditAll}
                listNVKDNew={listNVKDNew}
                setListNVKDNew={setListNVKDNew}
              />
            </div>

            <div class="row-form">
              <div class="row">
                <ThongTinHangBan
                  isShowGiaBan={isShowGiaBan}
                  isNhapCongThucNhanhTTK={isNhapCongThucNhanhTTK}
                  dataBanHang={dataBanHang}
                  setDataBanHang={setDataBanHang}
                  value={value}
                  setValue={setValue}
                  categoryNow={categoryNow}
                  setCategoryNow={setCategoryNow}
                  StoreID={StoreID}
                  setStoreID={setStoreID}
                  objDataStore={objDataStore}
                  roleGiaVon={roleGiaVon}
                  roleMaMc={roleMaMc}
                  roleBanCuon={roleBanCuon}
                  disEditDonGia={disEditDonGia}
                  disEditAll={disEditAll}
                  IsFocusTenSanPham={IsFocusTenSanPham}
                  setFocusTenSanPham={setFocusTenSanPham}
                  onSubmit={onSubmit}
                  IsFocusKho={IsFocusKho}
                  setFocusKho={setFocusKho}
                  GoiPhanMem={GoiPhanMem}
                  HienthiAutotrukhogiacong={HienthiAutotrukhogiacong}
                  isNhapThueGTGT={isNhapThueGTGT}
                  tatCanhBaoLuongTon={tatCanhBaoLuongTon}
                />
                <div class="col-md-12 ">
                  <div class=" row align-end">
                    <div class="footer-bottom-form col-md-12">
                      <button
                        class="button-Add-NoIcon bg-blue-main"
                        onClick={onSubmit}
                      >
                        Thêm vào đơn
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!--End-1--> */}
          {/* Bảng  */}
          <div class="content_New_Main-white">
            <h3 class="title-main">Chi tiết sản phẩm</h3>
            <TableSanPham
              dataBanHang={dataBanHang}
              isKGCXaGo={isKGCXaGo}
              setDataBanHang={setDataBanHang}
              objDataStore={objDataStore}
              sCode={sCode}
              disEditDonGia={disEditDonGia}
              disEditAll={disEditAll}
              listNhomSP={listNhomSP}
              setListNhomSP={setListNhomSP}
              setListChietKhauNhom={setListChietKhauNhom}
              listChietKhauNhom={listChietKhauNhom}
              lamTron={lamTron}
              GoiPhanMem={GoiPhanMem}
              HienthiAutotrukhogiacong={HienthiAutotrukhogiacong}
              tatCanhBaoLuongTon={tatCanhBaoLuongTon}
              isNhapThueGTGT={isNhapThueGTGT}
              isShowGiaBan={isShowGiaBan}
              valueSanPham={valueSanPham}
              setValueSanPham={setValueSanPham}
              isCanhBaoBanGiaTrungBinh={isCanhBaoBanGiaTrungBinh}
              isNhapCongThucNhanhTTK={isNhapCongThucNhanhTTK}
              roleBanCuon={roleBanCuon}
              roleMaMc={roleMaMc}
              roleGiaVon={roleGiaVon}
              roleSuaSP={roleSuaSP}
              isSuaDonBanGiaoNhan={isSuaDonBanGiaoNhan}
            />
            {isKGCXaGo === true && (
              <TableSanPhamSanPhamXaGo
                dataBanHang={dataBanHang}
                isKGCXaGo={isKGCXaGo}
                IsFocusTenSanPham={IsFocusTenSanPham}
                setDataBanHang={setDataBanHang}
                objDataStore={objDataStore}
                sCode={sCode}
                disEditDonGia={disEditDonGia}
                disEditAll={disEditAll}
                listNhomSP={listNhomSP}
                setListNhomSP={setListNhomSP}
                setListChietKhauNhom={setListChietKhauNhom}
                listChietKhauNhom={listChietKhauNhom}
                lamTron={lamTron}
                GoiPhanMem={GoiPhanMem}
                HienthiAutotrukhogiacong={HienthiAutotrukhogiacong}
                isNhapThueGTGT={isNhapThueGTGT}
                valueSanPham={valueSanPham}
                setValueSanPham={setValueSanPham}
              />
            )}
          </div>
          {/* End bảng */}

          <ThongTinThanhToan
            isShowTinhThanh={isShowTinhThanh}
            dataBanHang={dataBanHang}
            setDataBanHang={setDataBanHang}
            sCode={sCode}
            setDHQuaHanThanhToan={setDHQuaHanThanhToan}
            setListNhomSP={setListNhomSP}
            setPageActive={setPageActive}
            isShowMenu={isShowMenu}
            disEditAll={disEditAll}
            listChietKhauNhom={listChietKhauNhom}
            setListChietKhauNhom={setListChietKhauNhom}
            setDisEditAll={setDisEditAll}
            setDisEditKH={setDisEditKH}
            setDisEditDonGia={setDisEditDonGia}
            updateTienCKNhom={updateTienCKNhom}
            listChietKhauNhomKH={listChietKhauNhomKH}
            setListChietKhauNhomKH={setListChietKhauNhomKH}
            lamTron={lamTron}
            setLoadding={setLoadding}
          />
        </div>
      </>
    </LayoutNew>
  );
};
